<template>
  <div class="opinion_list" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="newsTitle" placeholder="搜索资讯标题" @change="onSearch" clearable></el-input>
      <el-select class="s_input" v-model="status" placeholder="资讯状态" @change="onSearch" clearable>
        <el-option label="启用" :value="1"></el-option>
        <el-option label="停用" :value="0"></el-option>
      </el-select>
      <el-button class="btn" type="primary" @click="onAdd">新增资讯</el-button>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="封面" min-width="100">
          <template slot-scope="scope">
            <span class="show_img" @click="previewPic(scope.row)">查看图片</span>
          </template>
        </el-table-column> -->
        <el-table-column show-overflow-tooltip min-width="140" prop="newsTitle" label="标题"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="createdUserName" label="发布人"></el-table-column>
        <!-- <el-table-column label="资讯类型" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.newsType == 1">行业动态</span>
            <span v-if="scope.row.newsType == 2">采门动态</span>
          </template>
        </el-table-column> -->
        <el-table-column show-overflow-tooltip prop="createdTime" label="发布时间" min-width="160"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="80" prop="sort" label="排序"></el-table-column>
        <el-table-column label="状态" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.switch" active-color="" inactive-color="#E2E2E2" @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="" plain @click="onEdit(scope.row)">修改</el-button>
            <el-button type="danger" plain @click="onDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="srcList"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      newsTitle: "",
      status: "",
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      showViewer: false,
      srcList: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$axios
        .get(this.$api.newsInfoselectPage, {
          params: {
            status: this.status,
            newsTitle: this.newsTitle,
            page: this.currentPage, // 页码数
            pageSize: this.pageSize, // 每页数量
          },
        })
        .then(res => {
          this.tableData =
            res.result.list.map(e => {
              return {
                ...e,
                switch: e.status == "1" ? true : false,
              }
            }) || []
          this.totalItemsCount = res.result.totalCount
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    changeStatus(row) {
      const originalSwitch = row.switch
      this.$confirm(`该资讯即将${row.switch ? "启用" : "停用"}，是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.newsInfoupdateStatus, {
              id: row.id,
              status: row.switch ? "1" : "0",
            })
            .then(() => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success("操作成功")
            })
            .catch(() => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error("操作失败")
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
        })
    },
    onAdd() {
      this.$router.push({ path: "/dynamic/list/detail/add", query: { type: 1 } })
    },
    onEdit(row) {
      this.$router.push({ path: "/dynamic/list/detail/add", query: { type: 2, id: row.id } })
    },
    onDel(row) {
      this.$confirm("此操作将永久删除该资讯, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(`${this.$api.newsInfodelete}/${row.id}`)
            .then(res => {
              this.$message.success(res.desc)
              this.getList()
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
    // 图片预览
    previewPic(e) {
      this.srcList = [e.coverPic]
      this.showViewer = true
    },
  },
}
</script>

<style scoped lang="scss">
.opinion_list {
  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .ruleForm {
    .picurl {
      width: 100px;
      height: 100px;
      border-radius: 6px;

      &:not(:first-child) {
        margin-left: 16px;
      }
    }

    .el-select {
      width: 100%;
    }

    ::v-deep .el-input,
    ::v-deep .el-input__inner {
      width: 100%;
    }
  }
}
</style>
